// extracted by mini-css-extract-plugin
export default {"wrapper":"DirectoryBadge_wrapper__LCgb6","img":"DirectoryBadge_img__f3cgZ","badgeCount":"DirectoryBadge_badgeCount__wE8BB"};